// engine-console-rules.ts — the engine console's pure rules (no client import, so they test outside the browser).
/** A key long enough to be one (the engine checks it; this only stops an obviously short one). */
export const looksLikeOperatorKey = (k: string) => k.trim().length >= 32;

/** (session 8, F1) Who finishes a run of this tenant — the engine console (`vms:covers`), the app (TubeForge's own
 *  `tubeforge:*`, growth included; no tenant known = the app, as before), or neither (another agency finishes its own).
 *  Only a convenience: the backend and the covers-worker each check the run's tenant themselves. */
export function finishingSide(tenantId: string | null | undefined): "engine" | "app" | "agency" {
  if (!tenantId) return "app";
  if (tenantId === "vms:covers") return "engine";
  return tenantId.split(":")[0] === "tubeforge" ? "app" : "agency";
}
